import { atom } from '@exodus/headless-ui';
import { WalletAccount } from '@exodus/models';
import toAssetAtom from './to-asset.js';
const INITIAL_VALUE = WalletAccount.DEFAULT_NAME;
const toWalletAccountNameAtom = atom(INITIAL_VALUE);
const toWalletAccountAtom = atom((get, { selectors }) => {
    const getWalletAccount = get(selectors.walletAccounts.get);
    const activeWalletAccountName = get(selectors.walletAccounts.active);
    const activeWalletAccount = getWalletAccount(activeWalletAccountName);
    const toWalletAccountName = get(toWalletAccountNameAtom);
    const toWalletAccount = getWalletAccount(toWalletAccountName);
    return toWalletAccount || activeWalletAccount || WalletAccount.DEFAULT;
}, (get, set, walletAccount, { selectors }) => {
    const newWalletAccountName = walletAccount?.toString() ?? INITIAL_VALUE;
    set(toWalletAccountNameAtom, newWalletAccountName);
    const toAsset = get(toAssetAtom);
    const assetsByWalletAccounts = get(selectors.assetSources.availableAssetNamesByWalletAccount);
    const assetsInWalletAccount = assetsByWalletAccounts[newWalletAccountName];
    if (assetsInWalletAccount && !assetsInWalletAccount.has(toAsset.name)) {
        set(toAssetAtom, undefined);
    }
});
export default toWalletAccountAtom;
